"use client";
import React, { useState, useEffect } from 'react';
import { motion } from 'framer-motion';
import { useNavigate } from 'react-router-dom';

import Breadcrumb from './Breadcrumb';
import Header from '../Header';
import emptyImg from './assets/empty.png';
import Footer from '../Footer';

const EmptyCart = () => {
  

  return (
    <div>
     <div className="w-full">
        <Header />
      </div>
    <main className="flex gap-7 p-10 w-full min-h-screen bg-neutral-50 max-xl:flex-col max-xl:gap-5 max-md:p-5 max-sm:p-4">
      {/* <div className="flex-shrink-0 w-[285px] max-xl:w-full">
        <FilterSidebar />
      </div> */}

      <section className="flex flex-col flex-1 gap-5 min-w-0">
        <div className="w-full">
          <Breadcrumb />
        </div>
        <header className="flex justify-between items-center max-sm:flex-col max-sm:items-start max-sm:gap-2">
          
         
        </header>
        <main className="flex-1 flex flex-col items-center justify-center text-center px-4">
        {/* Use your uploaded empty cart image */}
        <img
          src= "https://cdn.acsdev.in/Rentastic/empty.png"
          alt="Empty Cart"
          className="h-48 w-auto mb-6"
        />
        <h2 className="text-xl font-semibold mb-2">Your cart is empty</h2>
        <p className="text-gray-500">
          Seems like you have not added anything in your cart
        </p>
      </main>

       

       
      </section>
    </main>
    <div className="w-full">
        <Footer />
      </div>
    </div>
  );
};

export default EmptyCart;
